module.exports = __webpack_public_path__ + "static/media/brand.e4ce9883.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/brand.png
// module id = 145
// module chunks = 0